const getLimit = (xl, lg, md, sm, xs) => {
	if (xl) return 5;
	else if (lg) return 5;
	else if (md) return 3;
	else if (sm) return 2;
	else if (xs) return 2;
};

export default getLimit;
